import { getItem, setItem, removeItem } from "@/utils/storage";
import { createStore } from "vuex";
const USER_KEY = "USER_LJD"
const THIRD_KEY = "THIRD_LJD"
const store = createStore({
    state: {
        //存储当前登陆用户信息，包含token等数据
        userInfo: getItem(USER_KEY),
        thirdToken: getItem(THIRD_KEY)
    },
    mutations: {
        setUserInfo(state, data) {
            state.userInfo = data;
            setItem(USER_KEY, state.userInfo)
        },
        removeUserInfo(state) {
            removeItem(USER_KEY);
            state.userInfo = "";
        },
        setThirdToken(state, data) {
            state.thirdToken = data;
            setItem(THIRD_KEY, state.thirdToken)
        },
        removeThirdToken(state) {
            removeItem(THIRD_KEY)
            state.thirdToken = "";
        }
    },
});
export default store;